import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import styles from '../report.module.scss';
import formatCurrency from '../../../shared/utils/formatCurrency';
import { accountSelector } from '../../../shared/store/shared/accountSlice';
import UnavailableChipMetadata from '../../../shared/components/UnavailableChipMetadata';

export default function CommonColumns(
  dealId: string,
  reportType: string,
  isPayByUser: boolean,
) {
  const { currentAccountId } = useSelector(accountSelector);
  return [
    {
      name: 'Product Name',
      title: 'Product Name',
      cell: (cntx: {
        row: {
          original: {
            name: string;
            sku: string;
            retired?: boolean;
          };
        };
      }) => (
        <>
          <div className={`${styles.productNameCell}`}>
            <div className="d-flex">
              {cntx.row.original?.retired && <UnavailableChipMetadata />}
              <Link
                className="accent-link"
                to={`/admin/${currentAccountId}/reports/deal/${dealId}/sku/${cntx.row.original.sku}/${reportType}`}
              >
                <span
                  // eslint-disable-next-line react/no-danger
                  dangerouslySetInnerHTML={{ __html: cntx.row.original.name }}
                />
              </Link>
            </div>
          </div>
          <div className={styles.productSkuCell}>
            SKU: {cntx.row.original.sku}
          </div>
        </>
      ),
      width: 15,
    },
    {
      name: 'Total Spent',
      title: 'Total Spent',
      cell: (cntx: {
        row: {
          original: {
            priceRedeemed: number;
            totalSpend: number;
          };
        };
      }) => (
        <span className="label">{`$${formatCurrency(
          cntx.row.original.totalSpend,
        )}`}</span>
      ),
      width: 5,
    },
    !isPayByUser && {
      name: 'Total Quantity',
      title: 'Total Quantity',
      cell: (cntx: {
        row: {
          original: {
            quantityTotal: number;
          };
        };
      }) => <span className="label">{cntx.row.original.quantityTotal}</span>,
      width: 5,
    },
    {
      name: 'Available',
      title: 'Available',
      cell: (cntx: {
        row: {
          original: {
            retired?: boolean;
            quantityNotRedeemed: number;
          };
        };
      }) => {
        if (cntx.row.original.retired) {
          return <span className="label">0</span>;
        }

        if (isPayByUser) {
          return <span className="label">&#8734;</span>;
        }

        return (
          <span className="label">{cntx.row.original.quantityNotRedeemed}</span>
        );
      },
      width: 5,
    },
  ].filter(Boolean); // Removes the conditional Total Quantity when isPayByUser is true
}
